import { ENV } from "../utils";

export class Authority {
  baseApi = ENV.BASE_API;

  async getAuthorities(accessToken, active = true) {
    const url = `${this.baseApi}/authorities?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createAuthority(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-authority`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateAuthority(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-authority/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteAuthority(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-authority/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
